import Styles from './CardFront.module.scss'
import { CSSProperties, forwardRef } from 'react'
import { useSecretIdentity } from 'components/SecretIdentity/Provider'
import { CardProps } from 'components/SecretIdentity/Types'
import { Text } from 'blaze-ui/Text/Text'
import { DateTime } from 'components/DateTime/DateTime'
import { heroBgColors, heroColors, heroImages } from 'components/SecretIdentityModal/identities'
import { ReactComponent as BlazeLogo } from './blaze_logo.svg'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const CardFront = forwardRef<HTMLDivElement, CardProps>(({ imageKey, name, displayName, startDate }, ref) => {
  const fontSize = Math.max(Math.min((7 / (displayName?.length || 8)) * 48 - 4, 48), 24)
  const { isMobile } = useResponsiveDesign()

  const determinedFontSize = isMobile ? 21.97 : fontSize

  return (
    <div
      className={Styles.root}
      ref={ref}
      style={
        {
          '--display-name-font-size': `${determinedFontSize}px`,
          '--image': `url(${heroImages[imageKey]})`,
          '--color': heroColors[imageKey],
          '--background': heroBgColors[imageKey],
        } as CSSProperties
      }
    >
      <div className={Styles.content}>
        <img src={heroImages[imageKey]} className={Styles.image} alt={name} />
        <div className={Styles.info}>
          <div className={Styles.identity}>
            {(displayName?.length || 10) <= 10 && <h3 className={Styles.name}>{displayName}</h3>}
            {!isMobile && (
              <Text>
                <span className={Styles.description}>{name}</span>
              </Text>
            )}
          </div>
          <div className={Styles.details}>
            {!isMobile && (
              <span className={Styles.date}>
                {startDate && (
                  <>
                    <span>Joined </span>
                    <DateTime timestamp={startDate} format="ll" />
                  </>
                )}
              </span>
            )}
            <BlazeLogo className={Styles.logo} />
          </div>
        </div>
      </div>
    </div>
  )
})

const CardContainer = ({ imageKey }: Partial<CardProps>) => {
  const { secretIdentity, selectedIdentity, cardRef, displayName, startDate } = useSecretIdentity()

  return (
    <CardFront
      ref={cardRef}
      displayName={displayName}
      startDate={startDate}
      name={selectedIdentity?.name}
      imageKey={imageKey || secretIdentity?.hero_image_key || 'image_1'}
    />
  )
}

export { CardContainer as CardFront }
